import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

interface ChartCanvasProps {
  type: "line" | "bar" | "doughnut" | "pie";
  data: any;
  options?: any;
  height?: number;
}

/**
 * Тонкая обёртка над chart.js: создаёт график и пересоздаёт при изменении данных,
 * корректно уничтожая предыдущий инстанс (иначе chart.js ругается «canvas already in use»).
 */
const ChartCanvas: React.FC<ChartCanvasProps> = ({ type, data, options, height = 260 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const chartRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    chartRef.current?.destroy();
    chartRef.current = new Chart(canvasRef.current, {
      type,
      data,
      options: { responsive: true, maintainAspectRatio: false, ...(options || {}) },
    });
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [type, data, options]);

  return (
    <div style={{ height, position: "relative" }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default ChartCanvas;
